import React from 'react';

export function sortOptionsBySelected<T>(
  options: T[],
  selected: T[],
  isOptionEqualToValue: (value: T, option: T) => boolean,
): T[] {
  const sortedOptions = [];
  const unsortedOptions = [];
  for (const option of options) {
    if (
      selected.some((selectedOption) =>
        isOptionEqualToValue(selectedOption, option),
      )
    ) {
      sortedOptions.push(option);
    } else {
      unsortedOptions.push(option);
    }
  }
  return sortedOptions.concat(unsortedOptions);
}

export function getBooleanValueFromAriaAttribute(
  value?: boolean | 'true' | 'false',
): boolean {
  if (typeof value === 'boolean') {
    return value;
  }

  if (typeof value === 'string') {
    return value === 'true';
  }

  return false;
}

export function createSyntheticMouseEvent(
  keyboardEvent: React.KeyboardEvent<HTMLButtonElement>,
): React.MouseEvent<HTMLButtonElement> {
  const syntheticEvent = {
    ...keyboardEvent,
    type: 'click',
    button: 0,
    buttons: 1,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    screenX: 0,
    screenY: 0,
    movementX: 0,
    movementY: 0,
    relatedTarget: null,
    view: keyboardEvent.view,
    detail: 1,
    which: 1,
    bubbles: true,
    cancelable: true,
    currentTarget: keyboardEvent.currentTarget,
    defaultPrevented: false,
    eventPhase: 2,
    isTrusted: false,
    nativeEvent: keyboardEvent.nativeEvent,
    preventDefault: () => {
      // No-op for synthetic event
    },
    isDefaultPrevented: () => false,
    stopPropagation: () => {
      // No-op for synthetic event
    },
    isPropagationStopped: () => false,
    persist: () => {
      // No-op for synthetic event
    },
    target: keyboardEvent.target,
    timeStamp: keyboardEvent.timeStamp,
  } as unknown as React.MouseEvent<HTMLButtonElement>;

  return syntheticEvent;
}
